// extracted by mini-css-extract-plugin
export default {"language-toggle":"wSFhbf0lx_fKaOiiy2oP","active":"aELdOKfaJ8JtPJsTXHdK","inactive":"h55KbEjwzh8jTOBM0SPz"};